import CircularJSON from 'circular-json';
import _ from 'lodash';
import createRavenMiddleware from 'raven-for-redux';
import Raven from 'raven-js';

import {
  ErrorDescription,
  LoggerExtraParams,
} from '../error-logger/error-logger.types';

import { UserContext } from './logging.types';

export const setUserContext = ({ userId }: UserContext): void => {
  Raven.setUserContext({ userId });
};

export const setArtifactVersion = (artifactVersion: string): void => {
  Raven.setTagsContext({ artifactVersion });
};

type SentryError = Error | ErrorEvent | string;

function isSentryError(
  errorDescription: ErrorDescription,
): errorDescription is SentryError {
  return (
    errorDescription instanceof Error ||
    errorDescription instanceof ErrorEvent ||
    typeof errorDescription === 'string'
  );
}

export const logError = (
  errorDescription: ErrorDescription,
  extra: LoggerExtraParams = {},
): void => {
  const sentryException = isSentryError(errorDescription)
    ? errorDescription
    : new Error(CircularJSON.stringify(errorDescription));
  Raven.captureException(sentryException, { extra });
};

export const logInfo = (
  description: string,
  extra: LoggerExtraParams = {},
): void => {
  Raven.captureMessage(description, {
    extra,
    level: 'info',
  });
};

export const sentryMiddleware = createRavenMiddleware(Raven);
